import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Loading from './components/Loading';
import Notification from './components/Notification';
import Point from './components/points/Point';
import Dashboard from './pages/dashboard/Dashboard';
import ClusterMap from './components/map/ClusterMap';
import Points from './components/points/Points';
import AddPoint from './components/addPoint/AddPoint';
import AddTag from './components/addTag/AddTag';
import AboutUs from './components/aboutUs/AboutUs';
import UCIpoints from './components/uciPoints/UCIpoints';

const App = () => {
  return (
    <>
      <Loading />
      <Notification />
      <BrowserRouter>
        <Routes>
          {/* Main Home wrapper that contains the BottomNav */}
          <Route path="/" element={<Home />}>
            {/* These will render inside the <Outlet /> in Home.js */}
            <Route index element={<ClusterMap />} />
            <Route path="points" element={<Points />} />
            <Route path="add-point" element={<AddPoint />} />
            <Route path="add-tag" element={<AddTag />} />
            <Route path="ucipoints" element={<UCIpoints />} />
            <Route path="about" element={<AboutUs />} />
          </Route>
          
          <Route path="/point/:id" element={<Point />} />
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
